"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Errors = exports.EventCategories = exports.PublishMethods = void 0;
var PublishMethods;
(function (PublishMethods) {
    PublishMethods["Auto"] = "auto";
    PublishMethods["PostMessage"] = "postMessage";
    PublishMethods["Fetch"] = "fetch";
})(PublishMethods = exports.PublishMethods || (exports.PublishMethods = {}));
var EventCategories;
(function (EventCategories) {
    EventCategories["Essential"] = "essential";
    EventCategories["Functional"] = "functional";
    EventCategories["Analytics"] = "analytics";
})(EventCategories = exports.EventCategories || (exports.EventCategories = {}));
var Errors;
(function (Errors) {
    Errors[Errors["Unsupported"] = 0] = "Unsupported";
})(Errors = exports.Errors || (exports.Errors = {}));
//# sourceMappingURL=types.js.map